import { Button, Box } from "@mui/material";
import { Edit } from "@mui/icons-material";

import { Pickup } from "types/pickup";
import { address, contact, InfoCell, internalNotes, orderNumber } from "./shared";
import { Link as RouterLink } from "react-router-dom";

export function AllDrawer(props: { pickup: Pickup }) {
  const { pickup } = props;

  return (
    <Box mb={5} mx={2}>
      <Box
        sx={{
          py: 3,
          px: 4,
          background: "#FAFAFA",
          border: (theme) => `1px solid ${theme.palette.divider}`,
          borderRadius: 1,
        }}
      >
        <Box sx={{ display: "flex", gap: 2, flexWrap: "wrap" }}>
          <InfoCell title="EXTERNAL PICKUP ID" items={orderNumber(pickup)} />
          <InfoCell title="INTERNAL PICKUP ID" items={[pickup.id]} />
          <InfoCell title="POINT OF CONTACT" items={contact(pickup)} />
          <InfoCell title="PRE-PICKUP NOTES" items={internalNotes(pickup)} />
          {/* <InfoCell title="ATTACHMENTS" items={attachments(pickup)} /> */}
          <InfoCell title="LOCATION" items={address(pickup)} />
          <InfoCell
            title="LOCATION INFO"
            items={[pickup?.location?.accessInstructions, pickup?.location?.internalNotes]}
          />
          {/* <InfoCell title="POINT OF CONTACT" items={contact(pickup)} />
          <InfoCell title="PUBLISHED REPORTS" items={publishedReports(pickup)} />
          <InfoCell title="POST PICKUP REPORT" items={postPickupReport(pickup)} /> */}
        </Box>
      </Box>

      <Box mt={2} sx={{ display: "flex", justifyContent: "end", gap: 2 }}>
        <Button
          variant="contained"
          startIcon={<Edit />}
          component={RouterLink}
          to={`/logistics_platform/pickups/${pickup.uuid}/edit`}
        >
          pickup details
        </Button>
        <Button
          variant="contained"
          startIcon={<Edit />}
          component={RouterLink}
          to={`/logistics_platform/pickups/${pickup.uuid}/logistics`}
        >
          logistics details
        </Button>
      </Box>
    </Box>
  );
}
